import { render, staticRenderFns } from "./BillingInfoFieldset.vue?vue&type=template&id=80606fb4"
import script from "./BillingInfoFieldset.vue?vue&type=script&lang=ts"
export * from "./BillingInfoFieldset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports